
import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL +  "/api/MunfPatt";

export function getPagers(query) {
  return http.post(`${apiEndpoint}/GetPager?${query}`);
}

export function searchMunfPatt(search) {
  return http.post(
    `${apiEndpoint}/GetRep/?search=${search}`
  );
}

export function getMunfPattById(Id) {
  
  return http.get(`${apiEndpoint}/${Id}`);
}


export function getNewCode() {
  return http.post(`${apiEndpoint}/GetNewCode`);
}


export function initiale() {
  
  return http.post(`${apiEndpoint}/Initiale`);
}

export function editPattMunf(obj) {
  
  if (obj.id !== "new" && obj.id !== undefined ) {
    return http.put(apiEndpoint, obj);
  } else {
   return http.post(apiEndpoint, obj);
 }
}

export function deleteMunfPatt(Id) {
  return http.delete(`${apiEndpoint}/${Id}`);
}



